import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, TextField, Button, MenuItem, Modal, Box, IconButton, FormControlLabel, Checkbox } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

const OrderDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [orderDetails, setOrderDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('');
    const [pickupAddress, setPickupAddress] = useState('');
    const [pickupTime, setPickupTime] = useState('');
    const [pickupDate, setPickupDate] = useState('');
    const [material, setMaterial] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [modalImage, setModalImage] = useState('');
    const [endDate, setEndDate] = useState('');
    const [isForever, setIsForever] = useState(Boolean);


    const statusOptions = [
        'Pickup Scheduled',
        'Pickup Confirmed',
        'Payment Pending',
        'Order Completed',
        'Order Cancelled',
    ];

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {
                const token = JSON.parse(sessionStorage.getItem('accessToken'));
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/scrap/scrapDetails/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                const data = response.data.data;
                setOrderDetails(data);
                setStatus(data.status);
                setPickupAddress(data.address);
                setPickupTime(data.pickuptime);
                setPickupDate(data.pickupdate);
                setEndDate(data.pickupenddate);
                setMaterial(data.material);
                setIsForever(data.isforever);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchOrderDetails();
    }, [id]);

    const handleSave = async () => {
        try {
            const token = JSON.parse(sessionStorage.getItem('accessToken'));
            await axios.put(`${process.env.REACT_APP_API_URL}/user/scrap/scrapDetails/${id}`, {
                address: pickupAddress,
                pickupdate: pickupDate,
                pickupenddate: endDate,
                pickuptime: pickupTime,
                status: status,
                material: material,
                isforever: isForever,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            alert('Order updated successfully');
        } catch (err) {
            console.error(err);
            alert('Failed to update order');
        }
    };

    const handleImageClick = (image) => {
        setModalImage(image);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setModalImage('');
    };

    const handleIsForeverChange = (e) => {
        setIsForever(e.target.checked);
    };

    if (loading) return <Typography>Loading...</Typography>;
    if (!orderDetails) return <Typography>No details found</Typography>;

    const isGeneralCategory = orderDetails.category === 'general scrap';

    return (
        <div style={{ padding: '40px' }}>
            {/* <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate('/admin/getOrders')}
                style={{
                    position: 'absolute',
                    top: 10,
                    left: 50,
                }}
            >
                Back
            </Button> */}
            <Typography variant="h5" gutterBottom>Order Details</Typography>
            <Typography>Order ID: {orderDetails._id}</Typography>
            <Typography>Customer Name: {orderDetails.user.username}</Typography>
            <Typography>User Type: {orderDetails.user.usertype}</Typography>
            <Typography>Phone Number: {orderDetails.user.phone}</Typography>

            <Typography variant="h6" gutterBottom>Scrap Images:</Typography>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {orderDetails.scrapImages && typeof orderDetails.scrapImages === 'object' &&
                    Object.keys(orderDetails.scrapImages).map((key, index) => (
                        <img
                            key={index}
                            src={`data:image/jpeg;base64,${orderDetails.scrapImages[key]}`}
                            alt={`Scrap ${index + 1}`}
                            style={{ width: '150px', height: '150px', objectFit: 'cover', cursor: 'pointer' }}
                            onClick={() => handleImageClick(`data:image/jpeg;base64,${orderDetails.scrapImages[key]}`)}
                        />
                    ))
                }
            </div>

            {!isGeneralCategory && (
                <div>
                    <Typography variant="h6" gutterBottom>Vehicle Document:</Typography>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {orderDetails.vehicleDocument && (
                            <img
                                src={`data:image/jpeg;base64,${orderDetails.vehicleDocument}`}
                                alt="Vehicle Document"
                                style={{ width: '150px', height: '150px', objectFit: 'cover', cursor: 'pointer' }}
                                onClick={() => handleImageClick(`data:image/jpeg;base64,${orderDetails.vehicleDocument}`)}
                            />
                        )}
                    </div>
                </div>
            )}

            <TextField
                label="Pickup Address"
                value={pickupAddress}
                onChange={(e) => setPickupAddress(e.target.value)}
                fullWidth
                margin="normal"
            />
             {orderDetails.user.usertype === 'business' && orderDetails.pickupmode === 'custom' ? (
            <div>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isForever}
                            onChange={handleIsForeverChange}
                            color="primary"
                        />
                    }
                    label="Pickup Duration is Forever"
                />
                <TextField
                    label="Pickup Start Date"
                    type="date"
                    value={pickupDate}
                    onChange={(e) => setPickupDate(e.target.value)}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    disabled={isForever}
                />
                <TextField
                    label="Pickup End Date"
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    disabled={isForever}
                />
            </div>
        ) : (
            <TextField
                label="Pickup Date"
                value={pickupDate}
                onChange={(e) => setPickupDate(e.target.value)}
                fullWidth
                margin="normal"
                type="date"
                InputLabelProps={{
                    shrink: true,
                }}
            />
        )}
            <TextField
                label="Pickup Time"
                value={pickupTime}
                onChange={(e) => setPickupTime(e.target.value)}
                fullWidth
                margin="normal"
            />
            <TextField
                label="Material Description"
                value={material}
                onChange={(e) => setMaterial(e.target.value)}
                fullWidth
                margin="normal"
            />
            <Button variant="contained" color="primary" onClick={handleSave}>
                Save
            </Button>

            <TextField
                label="Status"
                select
                value={status}
                onChange={async(e) => {
                    const newStatus = e.target.value;
                    setStatus(newStatus);

                    try {
                        const token = JSON.parse(sessionStorage.getItem('accessToken'));
                        await axios.put(`${process.env.REACT_APP_API_URL}/user/scrap/scrapDetails/${id}`, {
                            status: newStatus,
                        },{
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        });
                        // alert('Status updated successfully');
                    } catch (err) {
                        console.error(err);
                        alert('Failed to update status');
                    }
                }}
                fullWidth
                margin="normal"
            >
                {statusOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </TextField>

            <Button
                variant="outlined"
                style={{ marginLeft: '10px' }}
                onClick={() => navigate(`/admin/wallet/${orderDetails.user._id}`, { state: { pickupDate, pickupAddress, material } })}
            >
                Go to Wallet
            </Button>

            <Modal open={openModal} onClose={handleCloseModal}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 2,
                        outline: 'none',
                        maxWidth: '90%',
                        maxHeight: '90%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <IconButton
                        onClick={handleCloseModal}
                        sx={{ position: 'absolute', top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <img
                        src={modalImage}
                        alt="Enlarged Scrap"
                        style={{ maxWidth: '100%', maxHeight: '100%' }}
                    />
                </Box>
            </Modal>
        </div>
    );
};

export default OrderDetails;
